module.exports = __webpack_public_path__ + "img/about-menu.bd56e3a3.jpg";